import React from 'react'
import Navbar from '../Collections/HomePage/Navbar/Navbar'
import Footer from '../Collections/HomePage/Footer/Footer'
import ErrorPage from '../Collections/ErrorPage/ErrorPage'

const ErrorPageGroup = () => {
  return (
    <>
        <Navbar/>
        <ErrorPage/>
        <Footer/>
    </>
  )
}

export default ErrorPageGroup